"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDesignerMode = exports.isCreatorModeSelected = exports.isCreatorMode = exports.isConfigurationModeSwitchAvailable = exports.isConfigurationModeAvailable = exports.getSelectedConfigurationMode = exports.getConfigurationModes = exports.getConfigurationModeOptions = exports.getAvailableLicenses = exports.getAvailableConfigurationModes = void 0;
var _flow = _interopRequireDefault(require("lodash/flow"));
var _isArray = _interopRequireDefault(require("lodash/isArray"));
var _createSelector = _interopRequireDefault(require("../../../Utils/Function/createSelector"));
var _get = _interopRequireDefault(require("lodash/get"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var getConfigurationModes = exports.getConfigurationModes = function getConfigurationModes(item) {
  var configurationModes = item && item.configurationModes;
  if (!(0, _isArray["default"])(configurationModes)) {
    return {};
  }
  return configurationModes.reduce(function (modeMap, mode) {
    return (0, _get["default"])(mode, 'itemStatus.item_available', false) ? _objectSpread(_objectSpread({}, modeMap), {}, _defineProperty({}, mode.identifier, true)) : modeMap;
  }, {});
};
var getConfigurationModeState = function getConfigurationModeState(_ref) {
  var configurationMode = _ref.configurationMode;
  return configurationMode;
};
var getSelectedMode = function getSelectedMode(_ref2) {
  var selectedMode = _ref2.selectedMode;
  return selectedMode;
};
var getAvailableModes = function getAvailableModes(_ref3) {
  var availableModes = _ref3.availableModes;
  return availableModes;
};
var getSelectedConfigurationMode = exports.getSelectedConfigurationMode = (0, _flow["default"])(getConfigurationModeState, getSelectedMode);
var getAvailableConfigurationModes = exports.getAvailableConfigurationModes = (0, _flow["default"])(getConfigurationModeState, getAvailableModes);
var getConfigurationModeOptions = exports.getConfigurationModeOptions = (0, _createSelector["default"])(getAvailableConfigurationModes, getSelectedConfigurationMode, function (availableModes, selectedMode) {
  return Object.keys(availableModes).filter(function (mode) {
    return mode !== selectedMode;
  });
});
var isConfigurationModeAvailable = exports.isConfigurationModeAvailable = (0, _createSelector["default"])(getAvailableConfigurationModes, function (modules) {
  return Object.values(modules).length > 0;
});
var isConfigurationModeSwitchAvailable = exports.isConfigurationModeSwitchAvailable = (0, _createSelector["default"])(getAvailableConfigurationModes, function (modules) {
  return Object.values(modules).length > 1;
});
var isCreatorModeSelected = exports.isCreatorModeSelected = (0, _createSelector["default"])(getSelectedConfigurationMode, function (mode) {
  return isCreatorMode(mode);
});
var isDesignerMode = exports.isDesignerMode = function isDesignerMode(modeStr) {
  return modeStr === 'designer';
};
var isCreatorMode = exports.isCreatorMode = function isCreatorMode(modeStr) {
  return modeStr === 'creator';
};
var getAvailableLicenses = exports.getAvailableLicenses = function getAvailableLicenses(data) {
  return data && data.license && data.license.split('+').filter(function (a) {
    return a;
  }) || [];
};